import React from 'react';
import {TouchableOpacity} from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import {COLORS} from '../../../utils/Constants';
import {tID} from '../../../utils/TestIdHelper';
import {useTheme, useThemedStyles} from '../../../theme';
import Text from '../Text';
import makeStyles from './styles';

const TextButton = ({
  onPress,
  title,
  fontSize = 18,
  buttonSize = 32,
  selected = false,
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <LinearGradient
      testID={tID('TextButton-LinearGradient-Main')}
      start={{x: 0.6, y: 0.6}}
      end={{x: 1, y: 1}}
      colors={
        // Selected gradient is decorative brand blue (docs/DARK-MODE.md
        // decorative list) — unthemed for now.
        selected
          ? [COLORS.blueGradient1, COLORS.blueGradient2]
          : [colors.transparent, colors.iconBorder]
      }
      style={styles.container(buttonSize)}
    >
      <TouchableOpacity
        testID={tID('TextButton-TouchableOpacity-Title')}
        activeOpacity={1}
        onPress={onPress}
        style={styles.buttonContainer(selected, buttonSize)}
      >
        <Text
          testID={tID('TextButton-Text-Title')}
          variation="Subtitle1SemiBold"
          color={selected ? colors.textOnAccent : colors.textDisabled}
        >
          {title}
        </Text>
      </TouchableOpacity>
    </LinearGradient>
  );
};

export default TextButton;
